import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-copy-icon lucide-copy",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 14,
		height: 14,
		x: 8,
		y: 8,
		rx: 2,
		ry: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })]
});
export default SvgCopy;
